import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    CRDATE: 'crdate',
    ADDRESS1: 'customer.address1',
    ADDRESS2: 'customer.address2',
    ADDRESS3: 'customer.address3',
    BAAN_NUMBER: 'customer.baan_number',
    BIKEEXPOUID: 'customer.bikeexpouid',
    BIRTHDAY: 'customer.birthday',
    CITY: 'customer.city',
    CODE: 'customer.code',
    COMPANY: 'customer.company',
    COMPANY_CODE: 'customer.company_code',
    COUNTRYID: 'customer.countryid',
    CUSTOMER_NUMBER: 'customer.customer_number',
    EMAIL: 'customer.email',
    FIRSTNAME: 'customer.firstname',
    GROUPS: 'customer.groups',
    ID: 'customer.id',
    LABEL: 'customer.label',
    LANGUAGEID: 'customer.languageid',
    LASTNAME: 'customer.lastname',
    LATITUDE: 'customer.latitude',
    LIMIT: 'customer.limit',
    LIMITSPENT: 'customer.limitspent',
    LONGITUDE: 'customer.longitude',
    POSTAL: 'customer.postal',
    SALUTATION: 'customer.salutation',
    STATE: 'customer.state',
    STATUS: 'customer.status',
    TELEFAX: 'customer.telefax',
    TELEPHONE: 'customer.telephone',
    TITLE: 'customer.title',
    VATID: 'customer.vatid',
    VELOPASSWORD: 'customer.velopassword',
    WEBSITE: 'customer.website',
    DATE_OF_BIRTH: 'date_of_birth',
    DISABLE: 'disable',
    GENDER: 'gender',
    TSTAMP: 'tstamp',
    TYPO3_PAGEID: 'typo3.pageid',
    DEFAULT_ADDRESS_ID: 'defaultAddressId',
    USER_FORM_DATA: 'userFormData',
    PARENT_BILLING_ADDRESS: 'parentBillingAddress',
    SUB_USER_TYPE: 'sub_user_type',
  },
}

export const PATHS = {
  CRDATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CRDATE],
  ADDRESS1: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS1],
  ADDRESS2: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS2],
  ADDRESS3: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS3],
  BAAN_NUMBER: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.BAAN_NUMBER],
  BIKEEXPOUID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.BIKEEXPOUID],
  BIRTHDAY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.BIRTHDAY],
  CITY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CITY],
  CODE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CODE],
  COMPANY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COMPANY],
  COMPANY_CODE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COMPANY_CODE],
  COUNTRYID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COUNTRYID],
  CUSTOMER_NUMBER: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CUSTOMER_NUMBER],
  EMAIL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.EMAIL],
  FIRSTNAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.FIRSTNAME],
  GROUPS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.GROUPS],
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  LABEL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LABEL],
  LANGUAGEID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LANGUAGEID],
  LASTNAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LASTNAME],
  LATITUDE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LATITUDE],
  LIMIT: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LIMIT],
  LIMITSPENT: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LIMITSPENT],
  LONGITUDE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LONGITUDE],
  POSTAL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.POSTAL],
  SALUTATION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SALUTATION],
  STATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATE],
  STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATUS],
  TELEFAX: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TELEFAX],
  TELEPHONE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TELEPHONE],
  TITLE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TITLE],
  VATID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.VATID],
  VELOPASSWORD: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.VELOPASSWORD],
  WEBSITE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.WEBSITE],
  DATE_OF_BIRTH: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DATE_OF_BIRTH],
  DISABLE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DISABLE],
  GENDER: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.GENDER],
  TSTAMP: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TSTAMP],
  TYPO3_PAGEID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TYPO3_PAGEID],
  DEFAULT_ADDRESS_ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DEFAULT_ADDRESS_ID],
  USER_FORM_DATA: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.USER_FORM_DATA],
  PARENT_BILLING_ADDRESS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PARENT_BILLING_ADDRESS],
  SUB_USER_TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SUB_USER_TYPE],
}

export default {
  CONSTANTS,
  PATHS,
}
